const config = window.wwttReactApp || {
  premiumUser: false,
  defaultRange: [0, 4],
  tooltipTexts: {
    continents: "",
    travelingWhileBlackScore: "",
    overallScore: "",
    thingsToDoScore: "",
    adventureScore: "",
    historyScore: "",
    relaxationScore: "",
    localFoodScore: "",
    romanceScore: "",
    nightlifeScore: "",
    affordabilityScore: "",
    travelStyle: "",
    tripType: "",
    travelPref: "",
    lodgingPref: "",
    cityCharacteristics: ""
  }
};

export default config;
